import React from 'react';
import PropTypes from 'prop-types';
import {
  getBestAvailableContactMethod,
  getEmailLink,
  getPhoneLink,
  getSmsLink
} from 'helpers/utilities';
import ContactButton from './ContactButton';
import IconButton from './IconButton';
import { REFERRAL } from '_constants';
// TODO: import PropertyInquirySection from './PropertyInquirySection';

import _ from 'lodash';

const CallNow = ({ ...props }) => {
  CallNow.propTypes = {
    activeReferral: PropTypes.object.isRequired,
    gotoDetailCard: PropTypes.func.isRequired
  };

  const getEmailTemplate = (contactMethod) => {
    const fullName = _.get(props, 'activeReferral.fullName', '');
    const leadSources = _.get(props, 'activeReferral.leadSources[0]', '');
    const member = _.get(props, 'userprofile', {});
    const property = _.get(props, 'properties.items[0].property', null);
    const { memberFullName = '', memberEmail = '', memberMobilePhone = '', memberPreferredPhone = '' } = member;
    let subject = '';
    let body = '';
    const phoneNumber = memberMobilePhone || memberPreferredPhone;
    // \n is needed to fix indentation issue in mail for desktop
    if (property && property.address) {
      const { address: { address1 = '', city = '', stateOrProvince = '' } } = property;
      subject = `RE: Your Inquiry for ${address1}, ${city}, ${stateOrProvince}`;
      body = `Hi, ${fullName},
        \nThank you for your inquiry. My name is ${memberFullName}, and I'm very excited to assist you with any specific questions you may have on the home or, perhaps, help you with scheduling a showing of the home.
        \nI'll be following-up shortly with a phone call. In the meantime, please do not hesitate to reach out to me directly at ${memberMobilePhone} or ${memberEmail}.
        \nBest Regards,
        \n${memberFullName} \n${phoneNumber} \n${memberEmail}
      `;
    } else {
      switch (leadSources.subLeadSource) {
        case 'Registration':
          subject = 'Here to offer real estate assistance';
          body = `Hi, ${fullName},
            \nAs you begin the home research process, I am happy to offer you my professional assistance and to be a resource on any homes you are interested in knowing more about.
            \nPlease do not hesitate to reach out to me directly at ${phoneNumber} or ${memberEmail}.
            \nBest regards,
            \n${memberFullName} \n${phoneNumber} \n${memberEmail}
          `;
          break;
        case 'Contact Form':
          subject = 'Available for your real estate questions and needs';
          body = `Hi, ${fullName},
            \nThank you for contacting us!
            \nMy name is ${member.memberFullName} and I'm very exicted to assist you with any specific questions you may have on a specific home or, perhaps help you with any other real estate needs.
            \nI'll be following-up shortly with a phone call. However, in the meantime, please do not hesitate to contact me directly at any time at ${member.memberMobilePhone} or ${member.memberEmail}.
            \nBest regards,
            \n${memberFullName} \n${phoneNumber} \n${memberEmail}
          `;
          break;
        default:
          break;
      }
    }

    return getEmailLink(contactMethod.email, subject, body);
  };

  const determineButtonType = (contactMethod) => {
    if (contactMethod.type === 'phone') {
      return <ContactButton
        label='Call Now!'
        icon='material-icons material-icons-call'
        href={getPhoneLink(contactMethod.number)}
        onClick={() => props.gotoDetailCard(REFERRAL.PENDING_APPOINTMENT_OUTCOME, 'Agent called lead')}
      />;
    }

    return <ContactButton
      label='Email Now!'
      icon='material-icons material-icons-email'
      href={getEmailTemplate(contactMethod)}
      onClick={() => props.gotoDetailCard(REFERRAL.PENDING_APPOINTMENT_OUTCOME, 'Agent emailed lead')}
    />;
  };

  const determineSubButtonType = (contactMethod) => {
    if ((contactMethod && contactMethod.type) === 'phone') {
      return (<div className='d-flex justify-content-center pt-3 pb-3'>
        <IconButton
          iconName='material-icons material-icons-chat'
          iconSize='h5'
          label='I Already<br /> Contacted'
          onClick={() => props.gotoDetailCard(REFERRAL.PENDING_APPOINTMENT_OUTCOME, 'Agent already contacted lead')}
        />
        <IconButton
          iconName='material-icons material-icons-email'
          iconSize='h3'
          label='Email'
          textColor={(getEmailLink(contactMethod.email) !== null) ? 'text-primary' : 'text-muted'}
          link={getEmailTemplate(contactMethod)}
          onClick={() => {
            if (getEmailLink(contactMethod.email) !== null) {
              props.gotoDetailCard(REFERRAL.PENDING_APPOINTMENT_OUTCOME, 'Agent emailed lead');
            }
          }}
        />
        <IconButton
          iconName='material-icons material-icons-chat-bubble'
          iconSize='h3'
          label='Text'
          link={getSmsLink(contactMethod.number)}
          onClick={() => props.gotoDetailCard(REFERRAL.PENDING_APPOINTMENT_OUTCOME, 'Agent texted lead')}
        />
      </div>);
    }

    return (<div className='d-flex justify-content-center pt-3 pb-3'>
      <IconButton
        iconName='material-icons material-icons-chat'
        iconSize='h5'
        label='I Already<br /> Contacted'
        onClick={() => props.gotoDetailCard(REFERRAL.PENDING_APPOINTMENT_OUTCOME, 'Agent already contacted lead')}
      />
    </div>);
  };

  const contactMethod = getBestAvailableContactMethod(props.activeReferral); 
  const buttonType = determineButtonType(contactMethod);
  const subButtonType = determineSubButtonType(contactMethod);

  return (
    <div>
      <div className='text-center pt-2'>
        {buttonType}
      </div>
      <div className='text-center'>
        {subButtonType}
      </div>
      {/* TODO: complete this. */}
      {/* <PropertyInquirySection
        hasPadding

        model={props.model}
        mlsLink={state.crmReducers.app.pages.contactDetails.isMlsClickable}
      /> */}
    </div>
  );
};

export default CallNow;
